const OptionOperationModel = {};

// see app/Types/Maps/ProductOptionOperationMap.php
OptionOperationModel.ADD = 1;
OptionOperationModel.MULTIPLY = 2;
OptionOperationModel.DISABLED = 3;

export default OptionOperationModel;
